# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/
$(document).on 'turbolinks:load', ->
  $("#fb").fancybox
    scrolling: "no"
    titleShow: false
    onClosed: ->
      $("#login_error").hide()

  $("#form_area").submit (event) ->
    event.preventDefault()
    text = $("#text").val()
    url = $(this).attr('action')
    #$.fancybox.showActivity()
    $.ajax
      type: "POST"
      cache: false
      url: url
      data: $(this).serializeArray()
      success: (data) ->
        $.fancybox data
    false
    